import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import * as api from '../api';

const LoginScreen = ({ onLogin, theme }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await api.login(email.trim().toLowerCase(), password);
      onLogin(result.user);
    } catch (err) {
      setError(err.message || 'Email ou senha incorretos.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center font-sans transition-colors duration-300" style={{ backgroundColor: theme?.primaryBg || '#0b0c10', color: theme?.textColor || '#e2e8f0' }}>
      <div className="p-8 rounded-xl border border-slate-700 shadow-2xl w-full max-w-md animate-in fade-in zoom-in-95 duration-300" style={{ backgroundColor: theme?.sidebarBg || '#181b26' }}>
        <div className="flex justify-center mb-6">
          {theme?.logoUrl ? <img src={theme.logoUrl} alt="Logo" className="h-16 max-w-full object-contain mb-2" /> : <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg"><Lock size={24} className="text-white" /></div>}
        </div>
        <h2 className="text-2xl font-bold text-center mb-2" style={{ color: theme?.textColor || '#ffffff' }}>{theme?.logoUrl ? '' : 'Photofine Pro'}</h2>
        <p className="text-center text-sm mb-8 opacity-70">Faça login para acessar a área de trabalho</p>
        {error ? <div className="bg-red-500/10 border border-red-500/50 text-red-400 p-3 rounded-lg text-sm mb-6 text-center">{error}</div> : null}
        <form onSubmit={handleLogin} className="flex flex-col gap-4">
          <div>
            <label className="block text-xs font-medium mb-1.5 opacity-70">Email de Acesso</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-black/20 border border-slate-600 rounded-lg px-4 py-2.5 outline-none focus:border-blue-500 transition-colors shadow-inner" style={{ color: theme?.textColor || '#ffffff' }} placeholder="admin@photo.com" required />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5 opacity-70">Senha</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-black/20 border border-slate-600 rounded-lg px-4 py-2.5 outline-none focus:border-blue-500 transition-colors shadow-inner" style={{ color: theme?.textColor || '#ffffff' }} placeholder="••••••••" required />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 rounded-lg mt-4 transition-colors shadow-md disabled:opacity-50 disabled:cursor-not-allowed">{loading ? 'Autenticando...' : 'Entrar no Sistema'}</button>
        </form>
        <div className="mt-6 pt-4 border-t border-slate-700 text-center text-xs text-slate-400 space-x-3">
          <a className="hover:text-blue-400 transition-colors" href="/legal/privacy" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
          <span>•</span>
          <a className="hover:text-blue-400 transition-colors" href="/legal/terms" target="_blank" rel="noopener noreferrer">Termos de Uso</a>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
